import { connect } from 'react-redux';
import { hideSendNoticeModal } from '../../../../actions/Modal';
import SendNoticeDialog from './SendNoticeDialog';

const mapStateToProps = ({ modal, noticeTemplates, notices }) => ({
  isOpen: modal.sendNoticeModal.visible,
  routes: modal.sendNoticeModal.routes,
  toRoute: modal.sendNoticeModal.toRoute,
  // task 09: optional cancel-composer prefill payload from the RouteDetails banner.
  prefilledDiversion: modal.sendNoticeModal.prefilledDiversion,
  templates: noticeTemplates.templates,
  isModalLoading: notices.isModalLoading,
});

export default connect(
  mapStateToProps,
  {
    hideSendNoticeModal,
  },
)(SendNoticeDialog);
